var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-unit"},[_c('span',[_vm._v(_vm._s(_vm.before))]),_c('el-input',_vm._b({ref:"input",attrs:{"id":"input","value":_vm.selfData,"placeholder":_vm.placeholder,"validate-event":""},on:{"change":_vm.change,"input":_vm.input}},'el-input',_vm.$attrs,false)),_c('span',[_vm._v(_vm._s(_vm.after))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }